// extracted by mini-css-extract-plugin
export var fadeIn = "_ex-1";
export var modalContent = "_ex-3";
export var overlay = "_ex-0";
export var popoverContent = "_ex-2";
export var results = "_ex-5";
export var searchInputWrapper = "_ex-4";